import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiPlace\CreateWikiPlaceController::__invoke
* @see app/Http/Controllers/WikiPlace/CreateWikiPlaceController.php
* @route '/api/place'
*/
const CreateWikiPlaceController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateWikiPlaceController.url(options),
    method: 'post',
})

CreateWikiPlaceController.definition = {
    methods: ["post"],
    url: '/api/place',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\WikiPlace\CreateWikiPlaceController::__invoke
* @see app/Http/Controllers/WikiPlace/CreateWikiPlaceController.php
* @route '/api/place'
*/
CreateWikiPlaceController.url = (options?: RouteQueryOptions) => {
    return CreateWikiPlaceController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiPlace\CreateWikiPlaceController::__invoke
* @see app/Http/Controllers/WikiPlace/CreateWikiPlaceController.php
* @route '/api/place'
*/
CreateWikiPlaceController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateWikiPlaceController.url(options),
    method: 'post',
})

export default CreateWikiPlaceController